
import { Component } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterModule, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from "../../../../shared/components/button/button.component";

@Component({
  standalone:true,
  selector: 'app-business-group',
  imports: [RouterModule, RouterOutlet, TranslateModule, RouterLink, RouterLinkActive, ButtonComponent],
  templateUrl: './business-group.component.html',
  styleUrl: './business-group.component.scss'
})
export class BusinessGroupComponent {
  // This method is used to initialize the class instance using router
  constructor(
    private router: Router
  ){

  }
  manager:any={
    initials: 'MA',
    name: 'Maithaa AlShuweihi',
    title: 'Relationship Manager',
    email: 'maithaa.alshuweihi@dcc.com',
    workingHours: '8:00 am to 4:00 pm GST'
  }
  tabs = [
    { route: 'about',              label: 'BUSINESS_GROUP.MEMBERS.TAB_ABOUT' },
    { route: 'members',            label: 'BUSINESS_GROUP.MEMBERS.TAB_MEMBERS' },
    { route: 'documents',          label: 'BUSINESS_GROUP.MEMBERS.TAB_DOCUMENTS' },
    { route: 'challenges-report',  label: 'BUSINESS_GROUP.MEMBERS.TAB_CHALLENGES_REPORT' },
    { route: 'manage-users',       label: 'BUSINESS_GROUP.MEMBERS.TAB_MANAGE_USERS' }
    // { route: 'manage-users',       label: 'BUSINESS_GROUP.MEMBERS.TAB_MANAGE_USERS' }
  ];

  // This method is used to active mobile route
  get activeMobileRoute(): string {
    return this.router.url.split('/').pop() ?? 'about';
  }

  /** navigate when user picks an option on mobile */
  // This method is used to go to using route
  goTo(route: any): void {
    this.router.navigate(['business-group', route.value]);
  }
}
